import { useGetIsUngated } from './useGetIsUngated';
import { GATES } from '../constants/auth';
export const useHasOrderedApprovalSteps = () => {
  const getIsUngated = useGetIsUngated();
  return getIsUngated(GATES.ORDERED_APPROVAL_STEPS) || getIsUngated(GATES.AGENT_APPROVER);
};